// Mobile contact button is now handled globally by MobileContactButton in App.tsx
export default function ContactSection() {
  return null;
}
